import React from 'react'
import Footer from './layout/Footer'
import { Outlet } from 'react-router-dom';
import Hadear1 from './layout/Hadear1';
import PopUp from '../pages/PopUp';

const MainLayOut = () => {
  return (
    <>
      {/* <Hadear /> */}
      <Hadear1 />
      <Outlet />
      <Footer />
      <PopUp />
      
    </>
  );
}

export default MainLayOut